/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractSnapshotFormComponent,
  formSchemaBuilderByEntityConfig,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getFormStateSnapshotValue,
  getRouteInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { assign } from 'lodash';
import {
  CS_MASTER_SUB_HEADING_INFO_ENTITY_CONFIG,
  CSMasterSubHeadingInfo,
} from '../../../resources/cs-master.model';

@Component({
  standalone: false,
  selector: 'gh-cs-master-detail-sub-heading-form',
  templateUrl: 'cs-master-detail-sub-heading-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsMasterDetailSubHeadingFormComponent extends AbstractSnapshotFormComponent<CSMasterSubHeadingInfo> implements OnInit {

  @Input() sequence: string;

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    assign(this, getRouteInitData(this.route));
  }

  protected buildForm(snapshot: FormStateSnapshot<CSMasterSubHeadingInfo>): FormState<CSMasterSubHeadingInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        ...formSchemaBuilderByEntityConfig(getFormStateSnapshotValue(snapshot),
                                           CS_MASTER_SUB_HEADING_INFO_ENTITY_CONFIG),
      },
    });
  }
}
